var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSandbox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.67275 0.736658C2.78253 0.44393 3.06237 0.25 3.375 0.25H13.2917C13.6043 0.25 13.8841 0.44393 13.9939 0.736658L15.9364 5.91675H11.2375C10.8233 5.91675 10.4875 6.25254 10.4875 6.66675C10.4875 7.8817 9.54829 8.82092 8.33333 8.82092C7.11838 8.82092 6.17916 7.8817 6.17916 6.66675C6.17916 6.25254 5.84338 5.91675 5.42916 5.91675H0.730219L2.67275 0.736658Z",
    fill: "#8C8AAC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 7.41561V10.8458C0.5 12.8892 2.11079 14.5 4.15417 14.5H12.5125C14.5559 14.5 16.1667 12.8892 16.1667 10.8458V7.41561C16.1529 7.41637 16.139 7.41675 16.125 7.41675H11.913C11.5744 9.09075 10.119 10.3209 8.33333 10.3209C6.54762 10.3209 5.09228 9.09075 4.75364 7.41675H0.541668C0.527686 7.41675 0.513793 7.41637 0.5 7.41561Z",
    fill: "#8C8AAC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSandbox);
export default __webpack_public_path__ + "static/media/sandbox.2ae7dc6c.svg";
export { ForwardRef as ReactComponent };